import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WalletRoutingModule } from './wallet-routing.module';
import { StateWiseAmountBalanceComponent } from './state-wise-amount-balance/state-wise-amount-balance.component';
import { StateWiseExpenditureComponent } from './state-wise-expenditure/state-wise-expenditure.component';
import { StateWiseExpenditureViewComponent } from './state-wise-expenditure-view/state-wise-expenditure-view.component';
import { AdminPaymentRequestsComponent } from './admin-payment-requests/admin-payment-requests.component';
import { StateWiseDistributionComponent } from './state-wise-distribution/state-wise-distribution.component';
import { WalletParentComponent } from './wallet-parent/wallet-parent.component';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddStateWalletBalanceComponent } from './add-state-wallet-balance/add-state-wallet-balance.component';
import { AddBranchWalletBalanceComponent } from './add-branch-wallet-balance/add-branch-wallet-balance.component';
import { TransactionDetailsComponent } from './transaction-details/transaction-details.component';
import { CustomDatePipe } from './transaction-details/customDate.pipe';
import { OrderDetailsModule } from '../order-details/order-details.module';

@NgModule({
  declarations: [
    StateWiseAmountBalanceComponent,
    StateWiseExpenditureComponent,
    StateWiseExpenditureViewComponent,
    AdminPaymentRequestsComponent,
    StateWiseDistributionComponent,
    WalletParentComponent,
    AddStateWalletBalanceComponent,
    AddBranchWalletBalanceComponent,
    TransactionDetailsComponent,
    CustomDatePipe,
  ],
  imports: [
    CommonModule,
    WalletRoutingModule,
    FormsModule,
    SharedComponentsModule,
    ReactiveFormsModule,
    OrderDetailsModule
  ],
})
export class WalletModule {}
